import React from 'react';

import ProteinChainPreview from 'molbio/aa-sequences/complex/AaSequenceChainPreview';
import {ProteinComplex} from 'molbio/aa-sequences/complex/AaSequenceComplexConstants';

export default function ProteinComplexPreviewBody({
  proteins,
}: {
  proteins: Array<ProteinComplex>;
}): JSX.Element {
  return (
    <div className="container u-spacing-top">
      {proteins.map((protein, i) => (
        <ProteinChainPreview key={i} name={protein.name} aminoAcids={protein.aminoAcids} />
      ))}
    </div>
  );
}
